import IndexTableFiltersPanelMultiSelect from '../index-table/filterComponents/IndexTableFiltersPanelMultiSelect';

export default class MessageIndexTableFiltersPanelMultiSelect extends IndexTableFiltersPanelMultiSelect {

    onChange = item => {
        let items = this.getItems();
        let selectedItem = items.find(x => x.value === item);

        // let values= props.value||  [];
        // values.push(item);
        let index = items.indexOf(selectedItem);
        this.props.onChange({
            text: selectedItem.text,
            value: item,
            index: index
        }, true)
    }

}